<template>
  <div class="form-group mb-3 row">
    <div class="col-sm-3">
      <label :class="{ required:required }">{{ label }}:</label>
    </div>
    <div class="col-sm-9">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["label","required"],
};
</script>


